module.exports = __webpack_public_path__ + "img/pressalit_2.aa3eb480.jpg";